import styled, { css } from "styled-components";
import { colors } from "healthex-common/colors";
import { FlexRow, FlexRowDiv } from "./common.styles";
import { LightText } from "./HXDesktopPage.styles";
import { fontSizes } from "healthex-common/sizes";
export const HXProgressBarContainer = styled.div `
    align-self: stretch;
    width: 100%;
    height: ${(props) => { var _a; return (_a = props.height) !== null && _a !== void 0 ? _a : 16; }}px;
    flex-shrink: 0;
    background: ${(props) => { var _a; return (_a = props.backgroundColor) !== null && _a !== void 0 ? _a : colors.black_12; }};
    overflow: hidden;
    position: relative;
`;
export const HXProgressBarInner = styled.div `
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: ${(props) => `${props.progress}%`};
    border-radius: ${(props) => `${props.progress >= 100 || props.rounded === false ? 0 : "0 100px 100px"}`};
    background: linear-gradient(135deg, ${colors.accents_gradient_start} 0%, ${colors.accents_sunset} 100%);

    ${(props) => props.backgroundColor &&
    css `
            background: ${props.backgroundColor};
        `}
`;
export const HXProgressBar2Container = styled(FlexRow) `
    gap: 8px;
    align-items: center;
`;
export const HXProgressBar2InnerContainer = styled(FlexRowDiv) `
    flex: 1 0 0;
    align-items: center;
`;
export const HXProgressBar2Text = styled(LightText) `
    font-size: ${fontSizes.SMALL};
    letter-spacing: 0.17px;
`;
